const scene = ( state = {}, action ) => {
    switch( action.type ){
        case "NEXT_SCENE":
            return Object.assign( {}, state, action.sceneData );
        default:
            return state;
    }
}
            
export default scene;



// WEBPACK FOOTER //
// ./src/reducers/scene.js